import { PropsWithChildren } from 'react'

import { StickyBar } from '@/shared/ui'

import { Period } from './period'
import { Price } from './price'

export type Props = {
  finalPayFee?: number
  week: number
  startDate: string
  endDate: string
  priceLabel?: string
  isExtend?: boolean
}

export const ContractStickyBar = ({
  finalPayFee,
  week,
  startDate,
  endDate,
  children,
  priceLabel,
  isExtend = false,
}: PropsWithChildren<Props>) => {
  return (
    <StickyBar className="gap-10">
      <div className="flex flex-col items-end justify-center text-white">
        <Period
          week={week}
          startDate={startDate}
          endDate={endDate}
          isExtend={isExtend}
        />
        {finalPayFee && <Price label={priceLabel} finalPayFee={finalPayFee} />}
      </div>
      {children}
    </StickyBar>
  )
}
